export default "__VITE_ASSET__BZz78v8w__"